import React from "react";

export default function NewRMGT9705LEDUVPress() {
    return (
        <div className="pt-16 pb-48 max-w-4xl mx-auto px-4">
            <h2 className="font-din text-[35px] font-bold">Lawton Connect Expands Capabilities with New RMGT 970-5 LED-UV Press Featuring Advanced LED Inks for Superior Print Production</h2>
            <div className="font-ibm mt-3">
                <p>
                    <strong>Orlando, FL – January 01, 2025</strong> – <a href="/">Lawton Connect</a>, a leader in
                    commercial printing, proudly
                    announces the acquisition of the RMGT 970-5, a cutting-edge five-color press with a coater and
                    advanced LED-UV technology. The new press, set to be installed in the company’s
                    35,000-square-foot Orlando facility, represents a bold investment in innovation, enabling faster
                    turnaround times, superior print quality, and unparalleled versatility across a range of print
                    applications. <br/> <br/>

                    At the forefront of this technological leap is the RMGT 970-5’s ability to utilize LED-curable inks,
                    which bring a host of advantages compared to traditional inks. Combined with the press’s
                    advanced features and flexible substrate compatibility, this enhancement positions Lawton Connect
                    to meet the dynamic needs of modern clients with efficiency and excellence.
                </p>
                <br/>
                <h4 className="underline font-bold text-xl mb-3">Key Features and Benefits of the RMGT 970-5 with LED
                    Inks:</h4>
                <h4 className="font-bold font-din text-xl mb-4 mt-4">LED-UV Curing and Advanced LED Inks</h4>
                <ul className="list-disc pl-5">
                    <li><strong>Faster Drying, Vibrant Results:</strong> LED-curable inks dry instantly under LED-UV
                        light,
                        reducing production times and allowing for vibrant, precise color reproduction on every
                        job. This rapid curing eliminates smudging and the need for extended drying times,
                        streamlining the printing process.
                    </li>
                    <li><strong>Enhanced Versatility:</strong> LED inks perform exceptionally on a broad range of
                        materials,
                        from heavy board stock to synthetic substrates, without sacrificing quality. They open
                        opportunities for innovative applications in packaging, marketing, and specialty printing.
                    </li>
                    <li><strong>Environmental Benefits:</strong> LED inks are eco-friendly, producing fewer emissions
                        and
                        using less energy compared to traditional inks and curing systems. This aligns with
                        Lawton Connect’s commitment to sustainability while offering a premium product.
                    </li>
                </ul>
                <h4 className="font-bold font-din text-xl mb-4 mt-4">Flexible Lamp and Curing Configurations</h4>
                <ul className="list-disc pl-5">
                    <li>The RMGT 970-5 is equipped with two repositionable LED lamps that can be
                        strategically placed between printing units or after the coater. This adaptability ensures
                        optimal curing for various substrates and coatings, enhancing print consistency and efficiency.
                    </li>
                </ul>
                <h4 className="font-bold font-din text-xl mb-4 mt-4">Coater Capabilities for Stunning Finishes</h4>
                <ul className="list-disc pl-5">
                    <li><strong>UV and Aqueous Coating Options:</strong> The press offers both UV and AQ coating
                        solutions, providing high-gloss, matte, and specialty finishes tailored to client needs.
                    </li>
                    <li><strong>Spot UV Coating:</strong> This advanced feature enables precise application of UV
                        coatings to
                        specific areas, adding texture, dimension, and a polished appearance to printed
                        materials. Spot UV is perfect for high-impact projects that demand attention-grabbing visuals.
                    </li>
                </ul>
                <h4 className="font-bold font-din text-xl mb-4 mt-4">Large Sheet Size and Precision Printing</h4>
                <ul className="list-disc pl-5">
                    <li> With a maximum sheet size of 25.59” x 38” and a printing area of 25.20” x 36.61”, the
                        RMGT 970-5 accommodates large-format projects with ease. Its automation and color
                        consistency ensure flawless results on every run, making it ideal for high-end
                        commercial printing and complex packaging jobs.
                    </li>
                </ul>
                <h4 className="font-bold font-din text-xl mb-4 mt-4">Boosted Productivity and Cost Efficiency</h4>
                <ul className="list-disc pl-5">
                    <li> The RMGT 970-5’s high-speed performance, paired with the efficiency of LED-curable
                        inks, reduces waste and operational costs. The instant drying of LED inks allows for
                        faster turnaround times, ensuring jobs are completed quickly and to the highest
                        standard.
                    </li>
                </ul>
                <br/>
                <p className="">
                    “The RMGT 970-5 with LED inks is a game-changer for our operations,” said Ty Koon, Vice
                    President of Lawton Connect. “This press combines the latest advancements in printing
                    technology, including the sustainability and versatility of LED inks, with the ability to deliver
                    stunning finishes and handle diverse substrates. It’s the perfect solution for creating innovative,
                    high-quality print products while meeting the ever-evolving needs of our clients. <br/> <br/>

                    The RMGT 970-5 press will enable Lawton Connect to enhance its suite of print services, from
                    eye-catching marketing materials to durable, high-end packaging solutions.
                    With LED inks and advanced coating options, the company is poised to provide creative, eco-friendly, and impactful
                    print solutions at an unmatched pace.
                </p>
                <br/>
                <h4 className="font-bold font-din text-xl mb-2">About Lawton Connect:</h4>
                <p>
                    Lawton Connect delivers innovative printing solutions to brand-conscious clients. Lawton&apos;s
                    solutions combine traditional craftsmanship with cutting-edge technology, offering seamless
                    interfaces, enhanced communication, and measurable results across complete offset, digital,
                    fulfillment, and distribution capabilities. Founded in 1900, this family-owned legacy prioritizes
                    trust and frictionless experiences, empowering creators to efficiently realize their visions. <br/>
                    <br/>
                    Lawton Connect is also home to three integrated brands that blend creativity and technology:
                    Mr. Playing Card, which specializes in custom affirmation and game cards; Mr. Scratch Off,
                    which focuses on scratch-off printing solutions; and Pinhole Press, which creates personalized,
                    photo-based products. <br/> <br/>
                </p>
            </div>
        </div>
    );
}